// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"Widgets_widgetContainer__2oy0o","item":"Widgets_item__39-oM"};